import { useEffect } from "react";
import { showNotification } from "@mantine/notifications";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthUser } from "react-auth-kit";
import { notifyListRefresh, useTabActionsOptional } from "../context/tabContext";
import { refreshEntityTabForMcaRequest } from "../utils/refreshEntityTabForMcaRequest";

const MCA_REQUESTS_LIST_PATH = "/mca/requests";

const ENTITY_REFRESH_TYPES = new Set([
  "APPROVED",
  "REJECTED",
  "TERMINATED",
  "CANCELLED",
]);

const useMcaNotification = (socket) => {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useAuthUser();
  const tabActions = useTabActionsOptional();

  useEffect(() => {
    if (!socket) return;

    const handler = (payload) => {
      notifyListRefresh(MCA_REQUESTS_LIST_PATH);

      if (ENTITY_REFRESH_TYPES.has(payload?.type)) {
        refreshEntityTabForMcaRequest(tabActions, {
          targetEntity: payload?.targetEntity,
          targetEntityId: payload?.targetEntityId,
          status: payload?.status ?? payload?.type,
          userRole: auth()?.userRole,
          currentPathname: location.pathname,
          payload: {
            orderId: payload?.orderId,
          },
        });
      }

      showNotification({
        title: payload?.type?.replace(/_/g, " ") ?? "MCA",
        message: payload?.message ?? `Request ${payload?.requestCode ?? ""}`,
        color:
          payload?.type === "APPROVED"
            ? "green"
            : payload?.type === "REJECTED" || payload?.type === "TERMINATED"
            ? "red"
            : "blue",
        onClick: () => {
          if (payload?.requestId) navigate(`/mca/requests/${payload.requestId}`);
        },
      });
    };

    socket.on("mcaNotification", handler);
    return () => socket.off("mcaNotification", handler);
  }, [socket, navigate, location.pathname, tabActions, auth]);
};

export default useMcaNotification;
